import { gql } from '@apollo/client'

export const FETCH_CLIENT_CONFIG = gql`
  query clientConfig {
    clientConfig {
      measurements {
        name
        metric {
          units
          precision
          minThreshold
          maxThreshold
        }
        imperial {
          units
          precision
          minThreshold
          maxThreshold
        }
      }
      activityTypes
      mealTypes
      dayTabs {
        key
        value
      }
      timeZones
      events {
        filters {
          types {
            key
            value
          }
          orderBy
          order
        }
      }
      meals {
        filters {
          types
          orderBy
          order
        }
      }
      insights {
        statistics {
          name
          metric {
            ranges {
              from
              to
              type
              rating
            }
            precision
            units
          }
          imperial {
            ranges {
              from
              to
              type
              rating
            }
            precision
            units
          }
        }
      }
      # todo: remove "biteAi" when there are no more users on app versions < 2.7.0
      biteAi {
        units {
          key
          value
        }
        dailyValues {
          key
          value
        }
      }
      healthKit {
        ignore
        sourceIgnore
      }
      customIngredients {
        macros {
          name
          indent
        }
      }
      settings {
        cancellationPolicy
        privacyPolicy
        termsOfUse
        telehealth
        consumerHealthDataPrivacyPolicy
        supportForm
        medicalDisclaimer
        courtesyReminder
        hipaaAuthorization
      }
      remindersSettings {
        hoursInterval {
          glucoseCheckOptions {
            text
            value
          }
        }
      }
      healthSettings {
        macroGoalSettings {
          caloriesMax
          proteinMax
          carbsMax
          fatMax
        }
        glucoseLowOptions {
          text
          value
        }
        glucoseHighOptions {
          text
          value
        }
        ketoneLowOptions {
          text
          value
        }
        ketoneHighOptions {
          text
          value
        }
        dashboardGraphOptions {
          text
          value
        }
        unitSystemOptions {
          text
          value
        }
        glucoseThresholdPresets {
          name
          description
          low
          high
        }
      }
      sensorSettings {
        baselineAdjustmentOptions {
          text
          value
        }
      }
      referral {
        title
        discount
        discountPercentage
        credits
        description
        message
        kind
      }
      onboarding {
        tutorials {
          key
          value {
            title
            description
            photoUrlLight
            photoUrlDark
            videoUrl
          }
        }
      }
      score {
        warning
        danger
        max
      }
      questionnaireUrl
      privacyCenterUrl
      usStates {
        name
        abbreviation
      }
      caProvinces {
        name
        abbreviation
      }
      goalOptions {
        text
        value
      }
      goalMetricOptions {
        text
        value
      }
      healthData {
        measurementTypeDefs {
          key
          label
          isDailyMeasurement
          isJournalMeasurement
          icon
        }
        measurementSourceDefs {
          key
          label
          providesDailyMeasurements
          sourceTags
          iconDef {
            pack
            name
          }
        }
      }
      journal {
        range {
          min
          max
        }
        measurementTypes {
          type
          reverse
        }
      }
      chatbot {
        lastShownCutoffAt
        responseTimeoutInSeconds
        disclosure
      }
      reminders {
        allowedFrequencies {
          key
        }
        icon
        key
        title
      }
      appointmentKinds {
        key
        duration
        title
        coachingKind {
          key
          coachTitle
          shortCoachTitle
          hubTitle
          shortHubTitle
          serviceTitle
          clinical
          insuranceReimbursable
          primary
        }
      }
      healthMetrics {
        key
        label
        unit
        kind
      }
      biomarkers {
        label
        unit
        kind
      }
      researchFaqs {
        gettingStartedUrl
      }
      insuranceKinds {
        kindDefs {
          key
          title
        }
      }
      specialtyKinds {
        key
        name
      }
      dexcomClientId
      dexcomSteloClientId
      uhcDeepLinks {
        storeUrl
      }
      labResults {
        fileUploadLimitMb
      }
      actionGoalOptions {
        kind
        title
        category
        icon
        description
        requiresGoalText
        allowsMultipleActiveGoalsForKind
        metricOptions {
          kind
          statKey
          trendSection
          supportsMetricValue
          valuePrefix
          description
          infoText
          metric {
            units
            min
            max
            increment
          }
          imperial {
            units
            min
            max
            increment
          }
        }
      }
      coaches {
        coachSwitchMaxSpecialtiesSelection
      }
    }
  }
`
